import React, { useState } from 'react';
import { BellIcon, CheckIcon, TrashIcon, CalendarCheckIcon, CreditCardIcon, UserIcon, AlertCircleIcon, SettingsIcon, FilterIcon } from 'lucide-react';
const NotificationsScreen = () => {
  const [filter, setFilter] = useState('all');
  // Sample notifications data
  const notifications = [{
    id: 1,
    title: 'New Duty Assigned',
    message: 'You have been assigned to "Ashara Security - Gate 1" on August 15, 2023.',
    date: '2023-08-15 10:30 AM',
    type: 'duty',
    read: false
  }, {
    id: 2,
    title: 'Lawajam Payment Received',
    message: 'Payment of ₹2,500 has been received from Ahmed Ali.',
    date: '2023-08-14 03:45 PM',
    type: 'lawajam',
    read: true
  }, {
    id: 3,
    title: 'New Member Added',
    message: 'Murtaza Husain has been added as a new member with Guard Level 1 rank.',
    date: '2023-08-13 11:20 AM',
    type: 'member',
    read: false
  }, {
    id: 4,
    title: 'Duty Completion Reminder',
    message: 'Reminder: "Weekly Meeting Security" duty is scheduled for today at 07:00 PM.',
    date: '2023-08-12 09:00 AM',
    type: 'duty',
    read: true
  }, {
    id: 5,
    title: 'System Maintenance',
    message: 'The system will undergo maintenance on August 20, 2023, from 02:00 AM to 04:00 AM.',
    date: '2023-08-11 05:30 PM',
    type: 'system',
    read: false
  }, {
    id: 6,
    title: 'Pending Lawajam Reminder',
    message: 'There are 4 pending lawajam payments that need attention.',
    date: '2023-08-10 02:15 PM',
    type: 'lawajam',
    read: true
  }, {
    id: 7,
    title: 'Member Status Updated',
    message: 'Yusuf Najmuddin\'s status has been changed to "On Leave" until August 25, 2023.',
    date: '2023-08-09 10:45 AM',
    type: 'member',
    read: true
  }, {
    id: 8,
    title: 'New Event Created',
    message: 'A new event "Community Gathering" has been created for August 20, 2023.',
    date: '2023-08-08 04:30 PM',
    type: 'duty',
    read: false
  }, {
    id: 9,
    title: 'Role Permissions Updated',
    message: 'Permissions for "Admin" role have been updated. Please review the changes.',
    date: '2023-08-07 01:20 PM',
    type: 'system',
    read: true
  }, {
    id: 10,
    title: 'Backup Completed',
    message: 'System backup has been successfully completed.',
    date: '2023-08-06 03:00 AM',
    type: 'system',
    read: true
  }];
  // Filter notifications based on selected filter
  const filteredNotifications = filter === 'all' ? notifications : filter === 'unread' ? notifications.filter(n => !n.read) : notifications.filter(n => n.type === filter);
  // Get icon based on notification type
  const getIcon = type => {
    switch (type) {
      case 'duty':
        return <CalendarCheckIcon size={20} className="text-blue-800" data-id="element-698" />;
      case 'lawajam':
        return <CreditCardIcon size={20} className="text-green-700" data-id="element-699" />;
      case 'member':
        return <UserIcon size={20} className="text-purple-700" data-id="element-700" />;
      case 'system':
        return <SettingsIcon size={20} className="text-gray-700" data-id="element-701" />;
      default:
        return <BellIcon size={20} className="text-blue-800" data-id="element-702" />;
    }
  };
  return <div className="space-y-6" data-id="element-703">
      <div className="flex justify-between items-center" data-id="element-704">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-705">Notifications</h1>
        <div className="flex space-x-2" data-id="element-706">
          <button className="border rounded-md px-3 py-1 text-sm hover:bg-gray-50 flex items-center" data-id="element-707">
            <CheckIcon size={16} className="mr-1" data-id="element-708" />
            Mark All as Read
          </button>
          <button className="border rounded-md px-3 py-1 text-sm hover:bg-gray-50 flex items-center text-red-600" data-id="element-709">
            <TrashIcon size={16} className="mr-1" data-id="element-710" />
            Clear All
          </button>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white p-4 rounded-lg shadow" data-id="element-711">
        <div className="flex items-center space-x-1" data-id="element-712">
          <FilterIcon size={18} className="mr-2 text-gray-500" data-id="element-713" />
          <button onClick={() => setFilter('all')} className={`px-3 py-1 rounded-md ${filter === 'all' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-714">
            All
          </button>
          <button onClick={() => setFilter('unread')} className={`px-3 py-1 rounded-md ${filter === 'unread' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-715">
            Unread
          </button>
          <button onClick={() => setFilter('duty')} className={`px-3 py-1 rounded-md flex items-center ${filter === 'duty' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-716">
            <CalendarCheckIcon size={16} className="mr-1" data-id="element-717" />
            Duties
          </button>
          <button onClick={() => setFilter('lawajam')} className={`px-3 py-1 rounded-md flex items-center ${filter === 'lawajam' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-718">
            <CreditCardIcon size={16} className="mr-1" data-id="element-719" />
            Lawajam
          </button>
          <button onClick={() => setFilter('member')} className={`px-3 py-1 rounded-md flex items-center ${filter === 'member' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-720">
            <UserIcon size={16} className="mr-1" data-id="element-721" />
            Members
          </button>
          <button onClick={() => setFilter('system')} className={`px-3 py-1 rounded-md flex items-center ${filter === 'system' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-722">
            <SettingsIcon size={16} className="mr-1" data-id="element-723" />
            System
          </button>
        </div>
      </div>
      {/* Notifications List */}
      <div className="bg-white rounded-lg shadow" data-id="element-724">
        {filteredNotifications.length === 0 ? <div className="flex flex-col items-center justify-center py-10" data-id="element-725">
            <BellIcon size={48} className="text-gray-300 mb-4" data-id="element-726" />
            <h3 className="text-lg font-medium text-gray-500" data-id="element-727">
              No notifications found
            </h3>
            <p className="text-gray-400" data-id="element-728">
              You don't have any {filter !== 'all' ? filter : ''} notifications
              at the moment
            </p>
          </div> : <div className="divide-y" data-id="element-729">
            {filteredNotifications.map(notification => <div key={notification.id} className={`p-4 hover:bg-gray-50 ${!notification.read ? 'bg-blue-50' : ''}`} data-id="element-730">
                <div className="flex" data-id="element-731">
                  <div className="mr-4 mt-1" data-id="element-732">
                    <div className="rounded-full bg-gray-100 p-2" data-id="element-733">
                      {getIcon(notification.type)}
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-734">
                    <div className="flex justify-between items-start" data-id="element-735">
                      <div className="font-medium" data-id="element-736">{notification.title}</div>
                      <div className="text-xs text-gray-500" data-id="element-737">
                        {notification.date}
                      </div>
                    </div>
                    <div className="text-gray-600 mt-1" data-id="element-738">
                      {notification.message}
                    </div>
                    <div className="flex justify-between items-center mt-3" data-id="element-739">
                      <div data-id="element-740">
                        {!notification.read && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800" data-id="element-741">
                            New
                          </span>}
                      </div>
                      <div className="flex space-x-2" data-id="element-742">
                        <button className="text-blue-600 text-sm hover:text-blue-800" data-id="element-743">
                          View
                        </button>
                        {!notification.read && <button className="text-gray-600 text-sm hover:text-gray-800" data-id="element-744">
                            Mark as Read
                          </button>}
                        <button className="text-red-600 text-sm hover:text-red-800" data-id="element-745">
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>}
        {/* Pagination */}
        <div className="bg-white px-4 py-3 flex items-center justify-between border-t" data-id="element-746">
          <div className="flex-1 flex justify-between sm:hidden" data-id="element-747">
            <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-748">
              Previous
            </button>
            <button className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-749">
              Next
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-750">
            <div data-id="element-751">
              <p className="text-sm text-gray-700" data-id="element-752">
                Showing <span className="font-medium" data-id="element-753">1</span> to{' '}
                <span className="font-medium" data-id="element-754">10</span> of{' '}
                <span className="font-medium" data-id="element-755">23</span> notifications
              </p>
            </div>
            <div data-id="element-756">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-757">
                <button className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-758">
                  <span className="sr-only" data-id="element-759">Previous</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-760">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-761" />
                  </svg>
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-blue-800 text-sm font-medium text-white" data-id="element-762">
                  1
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-763">
                  2
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-764">
                  3
                </button>
                <button className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-765">
                  <span className="sr-only" data-id="element-766">Next</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-767">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-id="element-768" />
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* Notification Preferences */}
      <div className="bg-white rounded-lg shadow p-6" data-id="element-769">
        <div className="flex justify-between items-center mb-4" data-id="element-770">
          <h2 className="text-lg font-medium text-gray-900" data-id="element-771">
            Notification Preferences
          </h2>
          <button className="text-blue-600 hover:text-blue-800 text-sm" data-id="element-772">
            View All Settings
          </button>
        </div>
        <div className="space-y-3" data-id="element-773">
          <div className="flex items-center justify-between" data-id="element-774">
            <div className="flex items-center" data-id="element-775">
              <CalendarCheckIcon size={18} className="mr-2 text-blue-800" data-id="element-776" />
              <span data-id="element-777">Duty Notifications</span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-778">
              <input type="checkbox" className="sr-only peer" checked data-id="element-779" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-780"></div>
            </label>
          </div>
          <div className="flex items-center justify-between" data-id="element-781">
            <div className="flex items-center" data-id="element-782">
              <CreditCardIcon size={18} className="mr-2 text-green-700" data-id="element-783" />
              <span data-id="element-784">Lawajam Notifications</span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-785">
              <input type="checkbox" className="sr-only peer" checked data-id="element-786" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-787"></div>
            </label>
          </div>
          <div className="flex items-center justify-between" data-id="element-788">
            <div className="flex items-center" data-id="element-789">
              <UserIcon size={18} className="mr-2 text-purple-700" data-id="element-790" />
              <span data-id="element-791">Member Notifications</span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-792">
              <input type="checkbox" className="sr-only peer" checked data-id="element-793" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-794"></div>
            </label>
          </div>
          <div className="flex items-center justify-between" data-id="element-795">
            <div className="flex items-center" data-id="element-796">
              <SettingsIcon size={18} className="mr-2 text-gray-700" data-id="element-797" />
              <span data-id="element-798">System Notifications</span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-799">
              <input type="checkbox" className="sr-only peer" data-id="element-800" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-801"></div>
            </label>
          </div>
        </div>
      </div>
    </div>;
};
export default NotificationsScreen;